import './Control.css'

const Control = ({ children }) => {
    return (
        <div className="control">
            {children}
        </div>
    );
}

export default Control;